import React from "react";
import { HangarsStateContainer } from "../../../containers/HangarsStateContainer";
import { RampsStateContainer } from "../../../containers/RampsStateContainer";
import { ScheduleDashboard as ScheduleDashboardComponent } from "./ScheduleDashboard";

export const ScheduleDashboard: React.FC = () => {
  return (
    <HangarsStateContainer isReference={false}>
      <RampsStateContainer isReference={false}>
        <ScheduleDashboardComponent />
      </RampsStateContainer>
    </HangarsStateContainer>
  );
};